import {
  GET_CAPEX_RELATED_BUDGET_INIT,
  GET_CAPEX_RELATED_BUDGET_SUCCESS,
  GET_CAPEX_RELATED_BUDGET_FAILED,
  GET_CAPEX_RELATED_FORECAST_INIT,
  GET_CAPEX_RELATED_FORECAST_SUCCESS,
  GET_CAPEX_RELATED_FORECAST_FAILED,
  GET_DIRECT_EMPLOYEE_BUDGET_INIT,
  GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS,
  GET_DIRECT_EMPLOYEE_BUDGET_FAILED,
  GET_DIRECT_EMPLOYEE_FORECAST_INIT,
  GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS,
  GET_DIRECT_EMPLOYEE_FORECAST_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED,
  GET_VENDOR_EMPLOYEE_BUDGET_INIT,
  GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
  GET_VENDOR_EMPLOYEE_BUDGET_FAILED,
  GET_VENDOR_EMPLOYEE_FORECAST_INIT,
  GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
  GET_VENDOR_EMPLOYEE_FORECAST_FAILED,
  GET_VENDOR_RELATED_COST_BUDGET_INIT,
  GET_VENDOR_RELATED_COST_BUDGET_SUCCESS,
  GET_VENDOR_RELATED_COST_BUDGET_FAILED,
  GET_VENDOR_RELATED_COST_FORECAST_INIT,
  GET_VENDOR_RELATED_COST_FORECAST_SUCCESS,
  GET_VENDOR_RELATED_COST_FORECAST_FAILED,
  UPDATE_CAPEX_RELATED_BUDGET_INIT,
  UPDATE_CAPEX_RELATED_BUDGET_SUCCESS,
  UPDATE_CAPEX_RELATED_BUDGET_FAILED,
  UPDATE_CAPEX_RELATED_FORECAST_INIT,
  UPDATE_CAPEX_RELATED_FORECAST_SUCCESS,
  UPDATE_CAPEX_RELATED_FORECAST_FAILED,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED,
  UPDATE_VENDOR_RELATED_COST_BUDGET_INIT,
  UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED,
  UPDATE_VENDOR_RELATED_COST_FORECAST_INIT,
  UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED,
  GET_FINANCIAL_SUMMARY_BUDGET_INIT,
  GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS,
  GET_FINANCIAL_SUMMARY_BUDGET_FAILED,
  GET_FINANCIAL_SUMMARY_FORECAST_INIT,
  GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS,
  GET_FINANCIAL_SUMMARY_FORECAST_FAILED,
  GET_TOP_PROJECT_VARIANCE_LIST_INIT,
  GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS,
  GET_TOP_PROJECT_VARIANCE_LIST_FAILED,
  GET_BUDGET_VS_FORECAST_INIT,
  GET_BUDGET_VS_FORECAST_SUCCESS,
  GET_BUDGET_VS_FORECAST_FAILED,
  GET_PROJECT_VARIANCES_COST_WATERFALL_INIT,
  GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS,
  GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED,
  GET_UPCOMING_DEADLINES_INIT,
  GET_UPCOMING_DEADLINES_SUCCESS,
  GET_UPCOMING_DEADLINES_FAILED,
  GET_CONTRACT_SUMMARY_INIT,
  GET_CONTRACT_SUMMARY_SUCCESS,
  GET_CONTRACT_SUMMARY_FAILED,
  GET_CONTRACT_SUMMARY_COST_PLUS_INIT,
  GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS,
  GET_CONTRACT_SUMMARY_COST_PLUS_FAILED,
  GET_CONTRACT_SUMMARY_EAC_FAILED,
  GET_CONTRACT_SUMMARY_EAC_INIT,
  GET_CONTRACT_SUMMARY_EAC_SUCCESS,
  GET_DIRECT_LABOR_DETAILS_INIT,
  GET_DIRECT_LABOR_DETAILS_SUCCESS,
  GET_DIRECT_LABOR_DETAILS_FAILED,
  GET_OTHER_DIRECT_COSTS_INIT,
  GET_OTHER_DIRECT_COSTS_SUCCESS,
  GET_OTHER_DIRECT_COSTS_FAILED,
  GET_REVENUE_INIT,
  GET_REVENUE_SUCCESS,
  GET_REVENUE_FAILED,
  GET_MARGIN_INIT,
  GET_MARGIN_SUCCESS,
  GET_MARGIN_FAILED,
  UPDATE_DIRECT_LABOR_DETAILS_INIT,
  UPDATE_DIRECT_LABOR_DETAILS_SUCCESS,
  UPDATE_DIRECT_LABOR_DETAILS_FAILED,
  UPDATE_OTHER_DIRECT_COSTS_INIT,
  UPDATE_OTHER_DIRECT_COSTS_SUCCESS,
  UPDATE_OTHER_DIRECT_COSTS_FAILED,
  UPDATE_REVENUE_INIT,
  UPDATE_REVENUE_SUCCESS,
  UPDATE_REVENUE_FAILED,
  UPDATE_MARGIN_INIT,
  UPDATE_MARGIN_SUCCESS,
  UPDATE_MARGIN_FAILED,
  GET_DETAILED_VIEW_RATES_INIT,
  GET_DETAILED_VIEW_RATES_SUCCESS,
  GET_DETAILED_VIEW_RATES_FAILED,
  GET_CONTRACT_YEARS_INIT,
  GET_CONTRACT_YEARS_SUCCESS,
  GET_CONTRACT_YEARS_FAILED,
  UPDATE_DETAILED_VIEW_RATES_INIT,
  UPDATE_DETAILED_VIEW_RATES_SUCCESS,
  UPDATE_DETAILED_VIEW_RATES_FAILED,
  GET_CONTRACTS_INIT,
  GET_CONTRACTS_SUCCESS,
  GET_CONTRACTS_FAILED,
  DOWNLOAD_DETAILED_VIEW_INIT,
  DOWNLOAD_DETAILED_VIEW_SUCCESS,
  DOWNLOAD_DETAILED_VIEW_FAILED,
  DOWNLOAD_PSR_INIT,
DOWNLOAD_PSR_SUCCESS,
DOWNLOAD_PSR_FAILED,

  GET_FINANCIAL_YEAR_SETTINGS_INIT,
  GET_FINANCIAL_YEAR_SETTINGS_SUCCESS,
  GET_FINANCIAL_YEAR_SETTINGS_FAILED,
  GET_FINANCIAL_YEARS_INIT,
  GET_FINANCIAL_YEARS_SUCCESS,
  GET_FINANCIAL_YEARS_FAILED,
  CREATE_FINANCIAL_YEARS_INIT,
  CREATE_FINANCIAL_YEARS_SUCCESS,
  CREATE_FINANCIAL_YEARS_FAILED,
  GET_VERSIONS_INIT,
  GET_VERSIONS_SUCCESS,
  GET_VERSIONS_FAILED,
  GET_DETAILED_VIEW_HEADERS_INIT,
  GET_DETAILED_VIEW_HEADERS_SUCCESS,
  GET_DETAILED_VIEW_HEADERS_FAILED,
  OPPORTUNITY_YEARS_LIST_INIT,
  OPPORTUNITY_YEARS_LIST_SUCCESS,
  SELECTED_OPP_YEAR_INIT,
  SELECTED_OPP_YEAR_SUCCESS,
} from "../actions/types/financial-management-types";

export const initialState = {
  capexRelatedBudgetData: [],
  capexRelatedForecastData: [],
  directEmployeeBudgetData: [],
  directEmployeeForecastData: [],
  otherDirectInhouseCostBudgetData: [],
  otherDirectInhouseCostForecastData: [],
  vendorEmployeeBudgetData: [],
  vendorEmployeeForecastData: [],
  vendorRelatedCostBudgetData: [],
  vendorRelatedCostForecastData: [],
  updateCapexRelatedBudgetData: "",
  updateCapexRelatedForecastData: "",
  updateDirectEmployeeBudgetData: "",
  updateDirectEmployeeForecastData: "",
  updateOtherDirectInhouseCostBudgetData: "",
  updateOtherDirectInhouseCostForecastData: "",
  updateVendorEmployeeBudgetData: "",
  updateVendorEmployeeForecastData: "",
  updateVendorRelatedCostBudgetData: "",
  updateVendorRelatedCostForecastData: "",
  finacialSummaryBudgetData: [],
  finacialSummaryForecastData: [],
  upcomingDeadLinesData: [],
  topProjectVariancesData: [],
  budgetVsForecastData: [],
  projectVarianceCostWaterfallData: [],
  contractSummaryData: [],
  directLaborDetailsData: [],
  otherDirectCostData: [],
  revenueData: [],
  marginData: [],
  updateData: false,
  loadingAPI: true,
  updatedDirectLaborData: "",
  updatedOtherCostsData: "",
  updatedMarginData: "",
  updatedRevenueData: "",
  detailedViewRatesData: "",
  contractYearsData: [],
  updateDetailedRatesData: "",
  contractsData: [],
  downloadDetailedViewData: "",
  downloadPsrData: "",
  financialYearSettingsData: [],
  financialYearsData: [],
  createdFinancialYearData: "",
  versionsData: [],
  detailedViewHeadersData: [],
  opportunityYearsList: [],
  selectedOppYear: "",
};

const handlers = {
  [GET_CAPEX_RELATED_BUDGET_INIT]: (state) => ({ ...state, loadingAPI: true }),
  [GET_CAPEX_RELATED_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    capexRelatedBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_CAPEX_RELATED_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_CAPEX_RELATED_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CAPEX_RELATED_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    capexRelatedForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_CAPEX_RELATED_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_DIRECT_EMPLOYEE_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    directEmployeeBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_DIRECT_EMPLOYEE_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_DIRECT_EMPLOYEE_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    directEmployeeForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_DIRECT_EMPLOYEE_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    otherDirectInhouseCostBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    otherDirectInhouseCostForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_EMPLOYEE_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    vendorEmployeeBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_EMPLOYEE_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_EMPLOYEE_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    vendorEmployeeForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_EMPLOYEE_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_RELATED_COST_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_RELATED_COST_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    vendorRelatedCostBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_RELATED_COST_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_VENDOR_RELATED_COST_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VENDOR_RELATED_COST_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    vendorRelatedCostForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_VENDOR_RELATED_COST_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_CAPEX_RELATED_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_CAPEX_RELATED_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    updateCapexRelatedBudgetData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_CAPEX_RELATED_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_CAPEX_RELATED_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_CAPEX_RELATED_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    updateCapexRelatedForecastData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_CAPEX_RELATED_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    updateDirectEmployeeBudgetData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    updateDirectEmployeeForecastData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    updateOtherDirectInhouseCostBudgetData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    updateOtherDirectInhouseCostForecastData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorEmployeeBudgetData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorEmployeeForecastData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_RELATED_COST_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorRelatedCostBudgetData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_VENDOR_RELATED_COST_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    updateVendorRelatedCostForecastData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_FINANCIAL_SUMMARY_BUDGET_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS]: (state, action) => ({
    ...state,
    finacialSummaryBudgetData: action.response,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_SUMMARY_BUDGET_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_FINANCIAL_SUMMARY_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    finacialSummaryForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_SUMMARY_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_BUDGET_VS_FORECAST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_BUDGET_VS_FORECAST_SUCCESS]: (state, action) => ({
    ...state,
    budgetVsForecastData: action.response,
    loadingAPI: false,
  }),
  [GET_BUDGET_VS_FORECAST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_TOP_PROJECT_VARIANCE_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    topProjectVariancesData: action.response,
    loadingAPI: false,
  }),
  [GET_TOP_PROJECT_VARIANCE_LIST_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_UPCOMING_DEADLINES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_UPCOMING_DEADLINES_SUCCESS]: (state, action) => ({
    ...state,
    upcomingDeadLinesData: action.response,
    loadingAPI: false,
  }),
  [GET_UPCOMING_DEADLINES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [GET_PROJECT_VARIANCES_COST_WATERFALL_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS]: (state, action) => ({
    ...state,
    projectVarianceCostWaterfallData: action.response,
    loadingAPI: false,
  }),
  [GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CONTRACT_SUMMARY_SUCCESS]: (state, action) => ({
    ...state,
    contractSummaryData: action.response,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_COST_PLUS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS]: (state, action) => ({
    ...state,
    contractSummaryCostPlusData: action.response,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_COST_PLUS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_EAC_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CONTRACT_SUMMARY_EAC_SUCCESS]: (state, action) => ({
    ...state,
    contractSummaryEACData: action.response,
    loadingAPI: false,
  }),
  [GET_CONTRACT_SUMMARY_EAC_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DIRECT_LABOR_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    directLaborDetailsData: state.updateData
      ? { ...state?.directLaborDetailsData, loading: true }
      : { loading: true },
  }),
  [GET_DIRECT_LABOR_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    directLaborDetailsData: { ...action.response, loading: false },
    updateData: false,
    loadingAPI: false,
  }),
  [GET_DIRECT_LABOR_DETAILS_FAILED]: (state) => ({
    ...state,
    directLaborDetailsData: { loading: false },
    loadingAPI: false,
  }),
  [GET_OTHER_DIRECT_COSTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    otherDirectCostData: state.updateData
      ? { ...state.otherDirectCostData, loading: true }
      : { loading: true },
  }),
  [GET_OTHER_DIRECT_COSTS_SUCCESS]: (state, action) => ({
    ...state,
    otherDirectCostData: { ...action.response, loading: false },
    updateData: false,
    loadingAPI: false,
  }),
  [GET_OTHER_DIRECT_COSTS_FAILED]: (state) => ({
    ...state,
    otherDirectCostData: { loading: false },
    loadingAPI: false,
  }),
  [GET_REVENUE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
    revenueData: state.updateData
      ? { ...state.revenueData, loading: true }
      : { loading: true },
  }),
  [GET_REVENUE_SUCCESS]: (state, action) => ({
    ...state,
    revenueData: { ...action.response, loading: false },
    updateData: false,
    loadingAPI: false,
  }),
  [GET_REVENUE_FAILED]: (state) => ({
    ...state,
    revenueData: { loading: false },
    loadingAPI: false,
  }),
  [GET_MARGIN_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_MARGIN_SUCCESS]: (state, action) => ({
    ...state,
    marginData: action.response,
    loadingAPI: false,
  }),
  [GET_MARGIN_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),

  [UPDATE_DIRECT_LABOR_DETAILS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_DIRECT_LABOR_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    updatedDirectLaborData: action.response,
    loadingAPI: false,
    updateData: true,
  }),
  [UPDATE_DIRECT_LABOR_DETAILS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_OTHER_DIRECT_COSTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_OTHER_DIRECT_COSTS_SUCCESS]: (state, action) => ({
    ...state,
    updatedOtherCostsData: action.response,
    loadingAPI: false,
    updateData: true,
  }),
  [UPDATE_OTHER_DIRECT_COSTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_REVENUE_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_REVENUE_SUCCESS]: (state, action) => ({
    ...state,
    updatedRevenueData: action.response,
    loadingAPI: false,
    updateData: true,
  }),
  [UPDATE_REVENUE_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_MARGIN_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_MARGIN_SUCCESS]: (state, action) => ({
    ...state,
    updatedMarginData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_MARGIN_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DETAILED_VIEW_RATES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DETAILED_VIEW_RATES_SUCCESS]: (state, action) => ({
    ...state,
    detailedViewRatesData: action.response,
    loadingAPI: false,
  }),
  [GET_DETAILED_VIEW_RATES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_CONTRACT_YEARS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CONTRACT_YEARS_SUCCESS]: (state, action) => ({
    ...state,
    contractYearsData: action.response,
    loadingAPI: false,
  }),
  [GET_CONTRACT_YEARS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [UPDATE_DETAILED_VIEW_RATES_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [UPDATE_DETAILED_VIEW_RATES_SUCCESS]: (state, action) => ({
    ...state,
    updateDetailedRatesData: action.response,
    loadingAPI: false,
  }),
  [UPDATE_DETAILED_VIEW_RATES_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_CONTRACTS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_CONTRACTS_SUCCESS]: (state, action) => ({
    ...state,
    contractsData: action.response,
    loadingAPI: false,
  }),
  [GET_CONTRACTS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_DETAILED_VIEW_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [DOWNLOAD_DETAILED_VIEW_SUCCESS]: (state, action) => ({
    ...state,
    downloadDetailedViewData: action.response,
    loadingAPI: false,
  }),
  [DOWNLOAD_DETAILED_VIEW_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [DOWNLOAD_PSR_INIT]: (state) => ({
  ...state,
  loadingAPI: true,
}),
[DOWNLOAD_PSR_SUCCESS]: (state, action) => ({
  ...state,
  downloadPsrData: action.response,
  loadingAPI: false,
}),
[DOWNLOAD_PSR_FAILED]: (state) => ({
  ...state,
  loadingAPI: false,}),
  [GET_FINANCIAL_YEAR_SETTINGS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FINANCIAL_YEAR_SETTINGS_SUCCESS]: (state, action) => ({
    ...state,
    financialYearSettingsData: action.response,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_YEAR_SETTINGS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_YEARS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_FINANCIAL_YEARS_SUCCESS]: (state, action) => ({
    ...state,
    financialYearsData: action.response,
    loadingAPI: false,
  }),
  [GET_FINANCIAL_YEARS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [CREATE_FINANCIAL_YEARS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [CREATE_FINANCIAL_YEARS_SUCCESS]: (state, action) => ({
    ...state,
    createdFinancialYearData: action.response,
    loadingAPI: false,
  }),
  [CREATE_FINANCIAL_YEARS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_VERSIONS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_VERSIONS_SUCCESS]: (state, action) => ({
    ...state,
    versionsData: action.response,
    loadingAPI: false,
  }),
  [GET_VERSIONS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [GET_DETAILED_VIEW_HEADERS_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [GET_DETAILED_VIEW_HEADERS_SUCCESS]: (state, action) => ({
    ...state,
    detailedViewHeadersData: action.response,
    loadingAPI: false,
  }),
  [GET_DETAILED_VIEW_HEADERS_FAILED]: (state) => ({
    ...state,
    loadingAPI: false,
  }),
  [OPPORTUNITY_YEARS_LIST_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [OPPORTUNITY_YEARS_LIST_SUCCESS]: (state, action) => ({
    ...state,
    opportunityYearsList: action.years,
    loadingAPI: false,
  }),
  [SELECTED_OPP_YEAR_INIT]: (state) => ({
    ...state,
    loadingAPI: true,
  }),
  [SELECTED_OPP_YEAR_SUCCESS]: (state, action) => ({
    ...state,
    selectedOppYear: action.year,
    loadingAPI: false,
  }),
};

export default function financialManagementReducer(
  state = initialState,
  action
) {
  const handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}
